// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as IncentiveApiModel from "../api-model/IncentiveApiModel.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function apiModelToState(res) {
  return List.map((function (campaign) {
                return {
                        campaign_id: campaign.campaign_id,
                        start_date: Timestamp$Catalyst.make(campaign.start_date),
                        end_date: Timestamp$Catalyst.make(campaign.end_date),
                        completed_trips: campaign.incentive_parameters.completed_trips,
                        abrtg_allowed: campaign.incentive_parameters.abrtg_allowed,
                        missed_order_allowed: campaign.incentive_parameters.missed_order_allowed,
                        fraud_allowed: campaign.incentive_parameters.fraud_allowed
                      };
              }), res.campaigns);
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(IncentiveApiModel.t_decode(json), "IncentiveApiModel.res"));
}

export {
  apiModelToState ,
  execute ,
  
}
/* Timestamp-Catalyst Not a pure module */
